import { AbstractPerformanceRequirementNote } from './abstract-performance-requirement-note.model';

export class UnknownPerformanceRequirementNote extends AbstractPerformanceRequirementNote {}
